import { useMemo } from 'react';
import { routeOrder, routeToTitle } from '../lib/routing';
import {
  routeOrder as spRouteOrder,
  routeToTitle as spRouteToTitle,
  SeasonPreviewRoutes,
} from '../lib/sp-routing';
import { usePathname } from 'next/navigation';

const useGuide = () => {
  const pathname = usePathname();

  type GuideRoute = keyof typeof routeToTitle;
  const currentRoute = pathname.split('?')[0] as GuideRoute;
  const currentRouteIdx =
    routeOrder.indexOf(currentRoute) >= 0
      ? routeOrder.indexOf(currentRoute)
      : 0;
  const currentTitle = routeToTitle[currentRoute];

  const nextRoute = routeOrder[currentRouteIdx + 1] as GuideRoute | undefined;
  const nextTitle = nextRoute && routeToTitle[nextRoute];
  const prevRoute = routeOrder[currentRouteIdx - 1] as GuideRoute | undefined;
  const prevTitle = prevRoute && routeToTitle[prevRoute];

  const value = useMemo(() => {
    const current = {
      route: currentRoute,
      title: currentTitle,
    };
    const next = {
      route: nextRoute,
      title: nextTitle,
    };

    const prev = {
      route: prevRoute,
      title: prevTitle,
    };
    return {
      next,
      prev,
      current,
    };
  }, [currentRoute, currentTitle, nextRoute, nextTitle, prevRoute, prevTitle]);

  return value;
};

export default useGuide;

export const useSPGuide = () => {
  const pathname = usePathname();

  const currentRoute = pathname as SeasonPreviewRoutes;
  const currentRouteIdx = spRouteOrder.indexOf(currentRoute);
  const currentTitle = spRouteToTitle[currentRoute];

  const nextRoute = spRouteOrder[currentRouteIdx + 1] as
    | SeasonPreviewRoutes
    | undefined;
  const nextTitle = nextRoute && spRouteToTitle[nextRoute];
  const prevRoute = spRouteOrder[currentRouteIdx - 1] as
    | SeasonPreviewRoutes
    | undefined;
  const prevTitle = prevRoute && spRouteToTitle[prevRoute];

  const value = useMemo(() => {
    const current = {
      route: currentRoute,
      title: currentTitle,
    };
    const next = {
      route: nextRoute,
      title: nextTitle,
    };

    const prev = {
      route: prevRoute,
      title: prevTitle,
    };

    return {
      next,
      prev,
      current,
    };
  }, [currentRoute, currentTitle, nextRoute, nextTitle, prevRoute, prevTitle]);

  return value;
};
